let klarnaScriptInserted = false;

const insertKlarnaScript = (clientId, enviroment) => {
  const klarnaScript = document.createElement("script");
  klarnaScript.setAttribute("data-client-id", clientId);
  klarnaScript.setAttribute("src", "https://js.klarna.com/web-sdk/v1/klarna.js");
  klarnaScript.setAttribute("async", "");
  klarnaScript.setAttribute("data-environment", enviroment);
  document.head.appendChild(klarnaScript);
};

export const eventuallyInsertKlarnaScript = async (clientId, enviroment) => {
  if (!klarnaScriptInserted) {
    klarnaScriptInserted = true;
    insertKlarnaScript(clientId, enviroment);
  }
};
